import React from "react";
import { Avatar, Card, CardHeader, CardContent, CardActions, Typography, IconButton, Link } from '@mui/material'
import { Favorite, Share } from '@mui/icons-material'
import { red } from "@mui/material/colors";

export const Announcements = () => {
  const date = new Date()
  let text = 'This impressive paella is a perfect party dish and a fun meal to cook together with your guests. Add 1 cup of frozen peas along with the mussels, if you like. This impressive paella is a perfect party dish and a fun meal to cook together with your guests. Add 1 cup of frozen peas along with the mussels, if you like.'
  let isLong = text.length > 250 && true;
  console.log(isLong)

  return (
    <>
      <Typography variant="h6">
          Announcements
        </Typography>
      <Card
        sx={{
          minWidth: 325,
          maxWidth: 600,
          boxShadow: "2px 2px 9px -4px rgba(0,0,0,0.75);",
        }}
      >
        <CardHeader
          avatar={<Avatar sx={{ bgColor: red[800] }}>Ad</Avatar>}
          title="Admininistator"
          subheader={date.toDateString()}
          sx={{ padding: "12px" }}
        ></CardHeader>
        <CardContent sx={{ padding: "12px" }}>
          <Typography variant="body2" color="text.secondary">
            {isLong ? `${text.slice(0, 251)} ` : text}
            {isLong ? <Link href="\info">more</Link> : ``}
          </Typography>
        </CardContent>
        <CardActions disableSpacing sx={{ padding: "2px" }}>
          <IconButton aria-label="add to favorites">
            <Favorite />
          </IconButton>
          <IconButton aria-label="share">
            <Share />
          </IconButton>
        </CardActions>
      </Card>
      <Card
        sx={{
          minWidth: 325,
          maxWidth: 600,
          boxShadow: "2px 2px 9px -6px rgba(0,0,0,0.75);",
        }}
      >
        <CardHeader
          avatar={<Avatar sx={{ bgColor: red[800] }}>At</Avatar>}
          title="Attendant"
          subheader={date.toDateString()}
          sx={{ padding: "12px" }}
        ></CardHeader>
        <CardContent sx={{ padding: "12px" }}>
          <Typography variant="body2" color="text.secondary">
            {isLong ? `${text.slice(0, 251)} ` : text}
            {isLong ? <Link href="\info">more</Link> : ``}
          </Typography>
        </CardContent>
        <CardActions disableSpacing sx={{ padding: "2px" }}>
          <IconButton aria-label="add to favorites">
            <Favorite />
          </IconButton>
          <IconButton aria-label="share">
            <Share />
          </IconButton>
        </CardActions>
      </Card>
      <Card
        sx={{
          minWidth: 325,
          maxWidth: 600,
          boxShadow: "2px 2px 9px -6px rgba(0,0,0,0.75);",
        }}
      >
        <CardHeader
          avatar={<Avatar sx={{ bgColor: red[800] }}>Ad</Avatar>}
          title="Admininistator"
          subheader={date.toDateString()}
          sx={{ padding: "12px" }}
        ></CardHeader>
        <CardContent sx={{ padding: "12px" }}>
          <Typography variant="body2" color="text.secondary">
            {isLong ? `${text.slice(0, 251)} ` : text}
            {isLong ? <Link href="\info">more</Link> : ``}
          </Typography>
        </CardContent>
        <CardActions disableSpacing sx={{ padding: "2px" }}>
          <IconButton aria-label="add to favorites">
            <Favorite />
          </IconButton>
          <IconButton aria-label="share">
            <Share />
          </IconButton>
        </CardActions>
      </Card>
    </>
  );
};
